import { Grid, Tab, Tabs, Tooltip } from "@mui/material";
import { PageHeader } from "../../../components/PageHeader";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export function ForumManagementPage() {
  const { t } = useTranslation(["common", "keyword", "social"]);
  const [currentTab, setCurrentTab] = useState("overview");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };
  return (
    <TrendzContainerCard title={t("social:forum_management_page")}>
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        style={{ marginBottom: "2px" }}
      >
        <Tab
          label={
            <Tooltip title={t("common:overview")}>
              <div>{t("common:overview")}</div>
            </Tooltip>
          }
          value="overview"
        ></Tab>
        <Tab
          label={
            <Tooltip title={t("social:deep_dive_into_users")}>
              <div>{t("social:users")}</div>
            </Tooltip>
          }
          value="users"
        ></Tab>
        <Tab
          label={
            <Tooltip title={t("social:deep_dive_into_posts")}>
              <div>{t("social:posts")}</div>
            </Tooltip>
          }
          value="posts"
        ></Tab>
      </Tabs>
    </TrendzContainerCard>
    // <Grid container>
    //   <Grid item xs={0.75}></Grid>
    //   <Grid item xs={10.5} className="white" marginTop={3}></Grid>
    //   <Grid item xs={0.75}></Grid>
    // </Grid>
  );
}
